import $ from "jquery";
let Legal_Tab;

const indexOf =
  [].indexOf ||
  function(item) {
    for (let i = 0, l = this.length; i < l; i++) {
      if (i in this && this[i] === item) return i;
    }
    return -1;
  };

Legal_Tab = (() => {
  function Legal_Tab() {
    let $tab_content;
    let $tab_list_items;
    let hash;
    let show_content;
    let tags;
    tags = ["#terms-of-use", "#privacy-policy", "#creator-terms"];
    hash = window.location.hash.replace("!", "");
    $tab_list_items = $(".tabnav li");
    $tab_content = $(".tab-content div");
    show_content = $this => {
      let hash_id;
      $tab_list_items.removeClass("active");
      $tab_content.removeClass("active");
      window.location.hash = $this.data("hash");
      hash_id = $this.data("hash").replace("!", "");
      return $(hash_id).addClass("active");
    };
    $("document").ready(e => {
      let $this;
      if (indexOf.call(tags, hash) < 0) {
        hash = "#terms-of-use";
      }
      $this = $(`.tabnav a[href="${hash}"]`);
      show_content($this);
      return $($this.parent()).addClass("active");
    });
    $(".tabnav a").on("click", function(e) {
      let $this;
      e.preventDefault();
      $this = $(this);
      show_content($this);
      return $($this.parent()[0]).addClass("active");
    });
  }

  return Legal_Tab;
})();

export default Legal_Tab;
